import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/rasket-theme.css';
import { AuthProvider } from './contexts/AuthContext';
import { DestekBildirimProvider } from './contexts/DestekBildirimContext';
import { FavoriSayfalarProvider } from './contexts/FavoriSayfalarContext';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Ozet from './pages/Ozet';
import ParaBirimleri from './pages/ParaBirimleri';
import DaireTipleri from './pages/DaireTipleri';
import Katlar from './pages/Katlar';
import Cepheler from './pages/Cepheler';
import Manzaralar from './pages/Manzaralar';
import BankaKredileri from './pages/BankaKredileri';
import KullaniciYonetimi from './pages/KullaniciYonetimi';
import KullaniciProfil from './pages/KullaniciProfil';
import Kasalar from './pages/Kasalar';
import KurumsalBilgiler from './pages/KurumsalBilgiler';
import Musteriler from './pages/Musteriler';
import MusteriDetay from './pages/MusteriDetay';
import MusteriRaporu from './pages/MusteriRaporu';
import Cariler from './pages/Cariler';
import CariDetay from './pages/CariDetay';
import Projeler from './pages/Projeler';
import ProjeDetay from './pages/ProjeDetay';
import ProjeSayfaGoruntule from './pages/ProjeSayfaGoruntule';
import TemaTest from './pages/TemaTest';
import SatisSozlesmesi from './pages/SatisSozlesmesi';
import Sozlesmeler from './pages/Sozlesmeler';
import SozlesmeDetay from './pages/SozlesmeDetay';
import SozlesmeOnaylari from './pages/SozlesmeOnaylari';
import Odemeler from './pages/Odemeler';
import DairelerListe from './pages/DairelerListe';
import DairelerTablo from './pages/DairelerTablo';
import IsPlan from './pages/IsPlan';
import IslemKayitlari from './pages/IslemKayitlari';
import FinansKategorileri from './pages/FinansKategorileri';
import CariAltKategorileri from './pages/CariAltKategorileri';
import KasaYonetimi from './pages/KasaYonetimi';
import FinansalOzet from './pages/FinansalOzet';
import Raporlar from './pages/Raporlar';
import RaporMerkezi from './pages/RaporMerkezi';
import ProjeRaporlari from './pages/ProjeRaporlari';
import StokErimeHizi from './pages/StokErimeHizi';
import StokBekleme from './pages/StokBekleme';
import PersonelPerformansRaporu from './pages/PersonelPerformansRaporu';
import NakitAkisProj from './pages/NakitAkisProj';
import EnvanterRaporu from './pages/EnvanterRaporu';
import TahsilatPerformans from './pages/TahsilatPerformans';
import HesapHareketleriRaporu from './pages/HesapHareketleriRaporu';
import KatPlaniSablonlari from './pages/KatKarsiligi/KatPlaniSablonlari';
import LeadTakip from './pages/LeadTakip';
import Ajanda from './pages/Ajanda';
import Fihrist from './pages/Fihrist';
import Dokumanlar from './pages/Dokumanlar';
import MetinEditoru from './pages/MetinEditoru';
import KrediHesaplama from './pages/KrediHesaplama';
import Ayarlar from './pages/Ayarlar';
import Destek from './pages/Destek';
import DokumanSablonlari from './pages/DokumanSablonlari';
import KiralikPortfoy from './pages/KiralikPortfoy';
import KiraSozlesmeler from './pages/KiraSozlesmeler';
import KiraSozlesmesiDetay from './pages/KiraSozlesmesiDetay';
import EmlakPortfoyListesi from './pages/EmlakPortfoyListesi';
import EmlakPortfoyForm from './pages/EmlakPortfoyForm';
import EmlakPortfoyDetay from './pages/EmlakPortfoyDetay';
import EmlakSunumlari from './pages/EmlakSunumlari';
import EmlakSunumlariDetay from './pages/EmlakSunumlariDetay';
import MusteriSunumlari from './pages/MusteriSunumlari';
import MusteriSunumDetay from './pages/MusteriSunumDetay';
import TeklifSozlesme from './pages/TeklifSozlesme';
import EmlakRapor from './pages/EmlakRapor';
import KatKarsiligArsa from './pages/KatKarsiligArsa';
import LeadStatusAyarlari from './pages/LeadStatusAyarlari';
import OdemePlanSablonlari from './pages/OdemePlanSablonlari';
import GayrimenkulFiyatlama from './pages/GayrimenkulFiyatlama';
import YapayZekaAyarlari from './pages/YapayZekaAyarlari';
import KatKarsiligArsaDetay from './pages/KatKarsiligArsaDetay';
import TaksitTakipPaneli from './pages/TaksitTakipPaneli';
import DashboardLayout from './layouts/DashboardLayout';
import PrivateRoute from './components/PrivateRoute';
import PermissionRoute from './components/PermissionRoute';
import SunumPortal from './pages/SunumPortal';
import RandevuOnay from './pages/RandevuOnay';
import OnlineRandevu from './pages/OnlineRandevu';

// v1.28.0 — Randevular Ajanda'nın içinde: eski /randevular bağlantıları (bildirimler: ?randevu=ID) Ajanda › Randevular'a gider
const RandevularYonlendir: React.FC = () => {
  const konum = useLocation();
  const p = new URLSearchParams(konum.search);
  p.set('bolum', 'randevular');
  return <Navigate to={`/ajanda?${p.toString()}`} replace />;
};

function App() {
  return (
    <AuthProvider>
      <DestekBildirimProvider>
      <FavoriSayfalarProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/portal/:token" element={<SunumPortal />} />
          <Route path="/randevu/:token" element={<RandevuOnay />} />
          <Route path="/randevu-al/:token" element={<OnlineRandevu />} />
          <Route path="/" element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="profil" element={<KullaniciProfil />} />
            <Route path="rapor-merkezi" element={<RaporMerkezi />} />
            <Route path="ozet" element={<PermissionRoute modul="Projeler"><Ozet /></PermissionRoute>} />
            <Route path="musteriler" element={<PermissionRoute modul="MusteriBilgileri"><Musteriler /></PermissionRoute>} />
            <Route path="musteriler-raporu" element={<PermissionRoute modul="MusteriBilgileri"><MusteriRaporu /></PermissionRoute>} />
            <Route path="musteriler/:id" element={<PermissionRoute modul="MusteriBilgileri"><MusteriDetay /></PermissionRoute>} />
            <Route path="cariler" element={<PermissionRoute modul="CariIslemleri"><Cariler /></PermissionRoute>} />
            <Route path="cariler/:id" element={<PermissionRoute modul="CariIslemleri"><CariDetay /></PermissionRoute>} />
            <Route path="projeler" element={<PermissionRoute modul="Projeler"><Projeler /></PermissionRoute>} />
            <Route path="projeler/:id" element={<PermissionRoute modul="Projeler"><ProjeDetay /></PermissionRoute>} />
            <Route path="projeler/:id/sayfa" element={<PermissionRoute modul="Projeler"><ProjeSayfaGoruntule /></PermissionRoute>} />
            <Route path="proje-raporlari" element={<PermissionRoute modul="Projeler"><ProjeRaporlari /></PermissionRoute>} />
            <Route path="stok-erime-hizi" element={<PermissionRoute modul="Projeler"><StokErimeHizi /></PermissionRoute>} />
            <Route path="stok-bekleme" element={<PermissionRoute modul="Projeler"><StokBekleme /></PermissionRoute>} />
            <Route path="personel-performans-raporu" element={<PermissionRoute modul="Projeler"><PersonelPerformansRaporu /></PermissionRoute>} />
            <Route path="sozlesmeler" element={<PermissionRoute modul="Projeler"><Sozlesmeler /></PermissionRoute>} />
            <Route path="sozlesme-detay/:takipNo" element={<PermissionRoute modul="Projeler"><SozlesmeDetay /></PermissionRoute>} />
            <Route path="sozlesme-onaylari" element={<PermissionRoute modul="Projeler"><SozlesmeOnaylari /></PermissionRoute>} />
            <Route path="finansal-islemler" element={<PermissionRoute modul="FinansalIslemler"><Odemeler /></PermissionRoute>} />
            <Route path="daireler/liste" element={<PermissionRoute modul="Projeler"><DairelerListe /></PermissionRoute>} />
            <Route path="daireler/tablo" element={<PermissionRoute modul="Projeler"><DairelerTablo /></PermissionRoute>} />
            <Route path="lead-takip" element={<PermissionRoute modul="PotansiyelMusteri"><LeadTakip /></PermissionRoute>} />
            <Route path="ajanda" element={<Ajanda />} />
            <Route path="randevular" element={<RandevularYonlendir />} />
            <Route path="is-plani" element={<PermissionRoute modul="IsPlan"><IsPlan /></PermissionRoute>} />
            <Route path="kasa-hareketleri" element={<PermissionRoute modul="FinansalIslemler"><KasaYonetimi /></PermissionRoute>} />
            <Route path="finansal-ozet" element={<PermissionRoute modul="FinansalIslemler"><FinansalOzet /></PermissionRoute>} />
            <Route path="taksit-takip" element={<PermissionRoute modul="FinansalIslemler"><TaksitTakipPaneli /></PermissionRoute>} />
            <Route path="raporlar" element={<PermissionRoute modul="FinansalIslemler"><Raporlar /></PermissionRoute>} />
            <Route path="nakit-akis-proj" element={<PermissionRoute modul="FinansalIslemler"><NakitAkisProj /></PermissionRoute>} />
            <Route path="envanter-raporu" element={<PermissionRoute modul="FinansalIslemler"><EnvanterRaporu /></PermissionRoute>} />
            <Route path="tahsilat-performans" element={<PermissionRoute modul="FinansalIslemler"><TahsilatPerformans /></PermissionRoute>} />
            <Route path="hesap-hareketleri-raporu" element={<PermissionRoute modul="FinansalIslemler"><HesapHareketleriRaporu /></PermissionRoute>} />
            <Route path="islem-kayitlari" element={<PermissionRoute modul="Ayarlar"><IslemKayitlari /></PermissionRoute>} />
            <Route path="satis-sozlesmesi" element={<PermissionRoute modul="Projeler"><SatisSozlesmesi /></PermissionRoute>} />
            <Route path="tema-test" element={<TemaTest />} />
            <Route path="emlak-portfoy" element={<PermissionRoute modul="Emlak"><EmlakPortfoyListesi /></PermissionRoute>} />
            <Route path="emlak-portfoy/yeni" element={<PermissionRoute modul="Emlak"><EmlakPortfoyForm /></PermissionRoute>} />
            <Route path="emlak-portfoy/duzenle/:id" element={<PermissionRoute modul="Emlak"><EmlakPortfoyForm /></PermissionRoute>} />
            <Route path="emlak-portfoy/:id" element={<PermissionRoute modul="Emlak"><EmlakPortfoyDetay /></PermissionRoute>} />
            <Route path="emlak-sunumlari" element={<PermissionRoute modul="Emlak"><EmlakSunumlari /></PermissionRoute>} />
            <Route path="emlak-sunumlari/:id" element={<PermissionRoute modul="Emlak"><EmlakSunumlariDetay /></PermissionRoute>} />
            <Route path="musteri-sunumlari" element={<PermissionRoute modul="Projeler"><MusteriSunumlari /></PermissionRoute>} />
            <Route path="musteri-sunumlari/:id" element={<PermissionRoute modul="Projeler"><MusteriSunumDetay /></PermissionRoute>} />
            <Route path="musteri-sunumlari/:id/teklif-sozlesme/:teklifId" element={<PermissionRoute modul="Projeler"><TeklifSozlesme /></PermissionRoute>} />
            <Route path="emlak-rapor" element={<PermissionRoute modul="Emlak"><EmlakRapor /></PermissionRoute>} />
            <Route path="fihrist" element={<PermissionRoute modul="Fihrist"><Fihrist /></PermissionRoute>} />
            <Route path="dokumanlar" element={<Dokumanlar />} />
            <Route path="metin-editoru" element={<MetinEditoru />} />
            <Route path="kredi-hesaplama" element={<KrediHesaplama />} />
            <Route path="ayarlar" element={<PermissionRoute modul="Ayarlar"><Ayarlar /></PermissionRoute>} />
            <Route path="destek" element={<Destek />} />
            <Route path="kiralik">
              <Route path="portfoy" element={<PermissionRoute modul="KiralikGayrimenkul"><KiralikPortfoy /></PermissionRoute>} />
              <Route path="sozlesmeler" element={<PermissionRoute modul="KiralikGayrimenkul"><KiraSozlesmeler /></PermissionRoute>} />
              <Route path="sozlesme-detay/:takipNo" element={<PermissionRoute modul="KiralikGayrimenkul"><KiraSozlesmesiDetay /></PermissionRoute>} />
            </Route>
            <Route path="kat-karsiligi">
              <Route index element={<PermissionRoute modul="KatKarsiligArsa"><KatKarsiligArsa /></PermissionRoute>} />
              <Route path=":id" element={<PermissionRoute modul="KatKarsiligArsa"><KatKarsiligArsaDetay /></PermissionRoute>} />
              <Route path="sablonlar" element={<PermissionRoute modul="KatKarsiligArsa"><KatPlaniSablonlari /></PermissionRoute>} />
            </Route>
            <Route path="tanimlamalar">
              <Route path="projeler" element={<PermissionRoute modul="Ayarlar"><div>Projeler Tanımlamaları</div></PermissionRoute>} />
              <Route path="daireler" element={<PermissionRoute modul="Ayarlar"><div>Daireler Tanımlamaları</div></PermissionRoute>} />
              <Route path="daire-tipleri" element={<PermissionRoute modul="Ayarlar"><DaireTipleri /></PermissionRoute>} />
              <Route path="katlar" element={<PermissionRoute modul="Ayarlar"><Katlar /></PermissionRoute>} />
              <Route path="cepheler" element={<PermissionRoute modul="Ayarlar"><Cepheler /></PermissionRoute>} />
              <Route path="manzaralar" element={<PermissionRoute modul="Ayarlar"><Manzaralar /></PermissionRoute>} />
              <Route path="banka-kredileri" element={<PermissionRoute modul="Ayarlar"><BankaKredileri /></PermissionRoute>} />
              <Route path="para-birimleri" element={<PermissionRoute modul="Ayarlar"><ParaBirimleri /></PermissionRoute>} />
              <Route path="kasalar" element={<PermissionRoute modul="Ayarlar"><Kasalar /></PermissionRoute>} />
              <Route path="finans-kategorileri" element={<PermissionRoute modul="Ayarlar"><FinansKategorileri /></PermissionRoute>} />
              <Route path="cari-alt-kategorileri" element={<PermissionRoute modul="Ayarlar"><CariAltKategorileri /></PermissionRoute>} />
              <Route path="kullanici-yonetimi" element={<PermissionRoute modul="KullaniciYonetimi"><KullaniciYonetimi /></PermissionRoute>} />
              <Route path="kurumsal-bilgiler" element={<PermissionRoute modul="Ayarlar"><KurumsalBilgiler /></PermissionRoute>} />
              <Route path="dokuman-sablonlari" element={<PermissionRoute modul="Ayarlar"><DokumanSablonlari /></PermissionRoute>} />
              <Route path="lead-durumlari" element={<PermissionRoute modul="Ayarlar"><LeadStatusAyarlari /></PermissionRoute>} />
              <Route path="odeme-plan-sablonlari" element={<PermissionRoute modul="Ayarlar"><OdemePlanSablonlari /></PermissionRoute>} />
              <Route path="gayrimenkul-fiyatlama" element={<PermissionRoute modul="Ayarlar"><GayrimenkulFiyatlama /></PermissionRoute>} />
              <Route path="yapay-zeka-ayarlari" element={<PermissionRoute modul="Ayarlar"><YapayZekaAyarlari /></PermissionRoute>} />
            </Route>
          </Route>
        </Routes>
      </Router>
      <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 999999 }} />
      </FavoriSayfalarProvider>
      </DestekBildirimProvider>
    </AuthProvider>
  );
}

export default App;